
<template>
  <div>
    <!-- <el-tooltip
      class="item"
      effect="light"
      content="点击编辑图片"
      placement="bottom-start"
      :disabled="imgSrc==''?true:false"
    > -->
    <el-upload
      class="avatar-uploader"
      action=""
      :show-file-list="false"
      :before-upload="beforeAvatarUpload"
      :http-request="upload"
    >
      <el-image
        v-if="imgSrc"
        style="width: 78px; height: 78px"
        :src="$store.state.config.fileUrl + imgSrc"
      >
      </el-image>
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      <!-- <el-tooltip class="item" effect="light" content="点击删除图片">
        <div v-if="imgSrc" @click.stop="removeImg" class="remove-icon"></div>
      </el-tooltip> -->
    </el-upload>
    <!-- </el-tooltip> -->
  </div>
</template>
<script>
export default {
  name: "HeadPortraitUpLoad",
  props: {
    imageUrl: {
      type: String,
      default: {
        return: ""
      }
    }
  },
  data() {
    return {
      imgSrc: this.imageUrl
    };
  },
  methods: {
    async upload(event) {
      // console.log(event)
      // return
      let res = await this.$Common.fileUploadNew(event);
      this.imgSrc = res.fileUrl;
      this.$emit("imageChange", this.imgSrc);
    },
    // handleAvatarSuccess(res, file) {
    //   this.imgSrc = Object.values(res.data)[0];
    //   this.$emit("imageChange", this.imgSrc);
    // },
    beforeAvatarUpload(file) {
      //   const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    removeImg() {
      this.$confirm("此操作将删除该图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteFile();
        })
        .catch(() => {
          console.log(111);
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    async deleteFile() {
      let isDelete = await this.$Common.delFile(this.imgSrc);
      if (isDelete) {
        this.imgSrc = "";
        this.$emit("imageChange", this.imgSrc);
        this.$message({
          type: "success",
          message: "删除成功!"
        });
      }
    }
  },
  watch: {
    imageUrl: function(val) {
      this.imgSrc = val || "";
    }
  }
};
</script>
<style scoped lang="scss">
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 78px;
  height: 78px;
}
.avatar-uploader :hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 78px;
  height: 78px;
  line-height: 78px;
  text-align: center;
}
.remove-icon {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0px;
  left: 58px;
  background: url("~@/assets/img/img/delete-icon.png") center center no-repeat;
  background-size: 100% 100%;
}
</style>
